import styled from 'styled-components';
import { Link } from 'gatsby';

const InternalLink = styled(Link).attrs(({ href }) => ({ to: href, href: undefined }))``;

export default InternalLink;
